<template>
  <div class="box box-solid score-box mb-2" data-widget="box-widget">
    <div
      class="box-header bg-brand-light"
      >
      <h3 class="d-flex box-title">
        <span >{{ title }} </span>
      </h3>
    </div>
    <div class="px-0">
      <VueApexCharts
        ref="apexchart"
        type="bar"
        height="300px"
        transition-duration="250"
        :options="createChartOptions"
        :series="formatScoresForSeries"
      />
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import moment from 'moment'


//define colors for bars
const POSITIVE = "#45f0b0";
const NEUTRAL = "#f0d845";
const NEGATIVE = "#f05345";

export default {
  props: [
    "active",
    "scores",
    "chartItemSelected",
    "title",
    "chartType"
  ],
  name: "ScoresChart",
  components: {
    VueApexCharts
  },
  created() {
    this.$root.$on("toggleDataSeries", seriesName => {
      this.$refs.apexchart.chart.toggleSeries(seriesName.toLowerCase());
    });
  },
  computed: {
    createChartOptions: function() {
      //expose a local instance of moment for our dateformtter
      let datesOfScores = this.datesOfScores();
      let chartItemSelected = this.chartItemSelected;
      let chartType = this.chartType;
      let title = this.title;

      const chartOptions = {
        chart: {
          stacked: true,
          toolbar: {
            show: false
          },
          stroke: {
            width: 2,
            colors: ["#fff"]
          },
          zoom: {
            enabled: false
          },
          events: {
            dataPointSelection: function(event, chartContext, config) {
              chartItemSelected(
                datesOfScores[config.dataPointIndex],
                config.seriesIndex,
                chartType
              );
            }
          }
        },
        colors: [NEGATIVE, NEUTRAL, POSITIVE],
        plotOptions: {
          bar: {
            borderRadius: 8,
            horizontal: false,
            columnWidth: "80%",
          }
        },

        legend: {
          show: false
        },
        xaxis: {
          type: "category",
          categories: this.datesOfScores(),
          axisBorder: {
            show: false
          },
          axisTicks: {
            show: false
          },
          labels: {
            show: true,
            formatter: function(val, opts) {
              return moment(val, "YYYY-MM-DD").format("MMM Do").toLowerCase();
            }
          }
          
        },
        yaxis: {
          show: true,
          logarithmic: false,
        },
        dataLabels: {
          enabled: true,
          textAnchor: "middle",
          offsetX: 0,
          offsetY: 0,
          style: {
            fontSize: "16px"
          },
          dropShadow: {
            enabled: true,
            top: 1,
            left: 1,
            blur: 1,
            opacity: 0.45
          }
        },
        /*
        title: {
          text: null,
          margin: 0,
          style: {
            fontSize: "18px"
          }
        },
        */
        grid: {
          padding: {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
          },
          yaxis: {
            lines: {
              show: false
            }
          },    
        }
      };

      return chartOptions;
    },

    formatScoresForSeries: function() {
      return [
        {
          name: "negative",
          data: this.formatSeriesValues("negatives")
        },
        {
          name: "neutral",
          data: this.formatSeriesValues("neutrals")
        },
        {
          name: "positive",
          data: this.formatSeriesValues("positives")
        }
        
        
      ];
    }
  },
  methods: {
    datesOfScores: function() {
      const dates = Object.keys(this.scores);

      return dates.sort();
    },
    formatSeriesValues: function(count_type) {
      const dates = Object.keys(this.scores);

      
      const formattedScores = dates.map(item => {
        return this.scores[item][count_type] || 0;
      });
      return formattedScores;
    }
  },
  watch: {
    active: function(val) {
      if (val == true) {
        this.$refs.apexchart.refresh();
      }
    }
  }
};
</script>